
export const productListKeywordStyle = theme => ({
    inlineList: {
        display: 'block'
    },
})